import { cardResource, CardResource } from '@witkac/kartamiejska-resources';
import { Card } from '@witkac/kartamiejska-shared';
import { VariableType } from 'json-to-graphql-query';

import { EntityModule } from './entity.module';

export class CardModule extends EntityModule<Card, CardResource> {
  constructor() {
    super(cardResource);

    this.state = {
      ...this.state,
      customList: []
    } as any;

    this.mutations = {
      ...this.mutations,
      setCustomList(localState: any, list: any): void {
        localState.customList = list;
      }
    } as any;

    this.actions = {
      ...this.actions,

      /**
       * Aktualizacja statusu kart na `READY`
       *
       * @param {*} context
       * @param {*} args
       */
      cardsReady: (context: any, args: any) => this.resource.setReadyState(args),

      /**
       * Aktualizacja statusu kart na `PREPARED`
       *
       * @param {*} context
       * @param {*} args
       */
      cardsPrepared: (context: any, args: any) => this.resource.setPreparedState(args),

      /**
       * Aktualizacja statusu kart na `TRANSPORT`
       *
       * @param {*} context
       * @param {*} args
       */
      cardsTransport: (context: any, args: any) => this.resource.setTransportState(args),

      /**
       * Aktualizacja statusu kart na `PREPARED_TO_PRINT`
       *
       * @param {*} context
       * @param {*} args
       */
      cardsPreparedToPrint: (context: any, args: any) => this.resource.setPreparedToPrintState(args),

      /**
       * Cofnięcie kart ze statusu PRINTED do PREPARED_TO_PRINT (ponowny wydruk)
       *
       * @param {*} context
       * @param {*} args
       */
      cardsReprint: (context: any, args: any) => {
        const mutation = this.resource.prepareOptions({
          mutation: {
            __variables: { ids: '[Int!]!' },
            cardsReprint: {
              __args: {
                ids: new VariableType('ids')
              }
            }
          }
        });
        return this.resource.mutation({ mutation, variables: { ids: args } }, 'cardsReprint');
      },

      /**
       * Ustawienie kart seniorów jako bezterminowych
       *
       * @param {*} context
       */
      seniorCardSetAsUnlimited: (context: any, args: any) => this.resource.seniorCardSetAsUnlimited(args),

      /**
       * Pobieranie listy
       *
       * @param {*} context
       * @param {*} args
       * @returns {Promise<void>}
       */
      customList: async (context: any, args: any): Promise<Card[]> => {
        const { list } = await this.resource.list(args.filters, undefined, args.fields);
        context.commit('setCustomList', list);
        return list;
      }
    };
  }
}

export default new CardModule();
